/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {InjectionToken} from '@angular/core';

export const FILE_STORAGE_CONFIG = new InjectionToken<{ apiUrl: string }>('FILE_STORAGE_CONFIG');
